import {
    LOAD_IMPUTATIONS_BY_DAY,
    ADD_IMPUTATION,
    UPDATE_IMPUTATION,
    DELETE_IMPUTATION,
    SET_ALL_IMPUTATIONS,
    SET_CURRENT_OR_LAST_IMPUTATION,
    SET_INTERVENTIONS_FOR_IMPUTATIONS,
} from "./imputationsConstants";
import { setValue } from "../../lib/immutable_wrapper";

const initialState = {
    allImputations: [],
    currentOrLastImputation: null,
};

const interventionsInitialState = {
    allInterventions: [],
};

export function imputations(state = initialState, action) {
    switch (action.type) {
        case SET_ALL_IMPUTATIONS:
            return setValue(state, ["allImputations"], action.imputations);
        case SET_CURRENT_OR_LAST_IMPUTATION:
            return setValue(state, ["currentOrLastImputation"], action.currentOrLastImputation);
        default:
            return state;
    }
}

export function interventionsImputations(state = interventionsInitialState, action) {
    switch (action.type) {
        case SET_INTERVENTIONS_FOR_IMPUTATIONS:
            return setValue(state, ["allInterventions"], action.interventions);
        default:
            return state;
    }
}

export function activeDayImputations(state = [], action) {
    switch (action.type) {
        case LOAD_IMPUTATIONS_BY_DAY:
            return action.imputations;
        case ADD_IMPUTATION:
            return [...state, action.newImputation];
        case UPDATE_IMPUTATION: {
            let imputationToUpdate = state.find((imputation) => imputation.id === action.imputation.id);
            return [
                ...state.filter((imputation) => imputation.id !== imputationToUpdate.id),
                Object.assign({}, imputationToUpdate, action.imputation),
            ];
        }
        case DELETE_IMPUTATION:
            return state.filter((imputation) => imputation.id !== action.idImputation);
        default:
            return state;
    }
}
